import React from "react";
import { Routes, Route, Switch } from "react-router-dom";
import CarrierPage from "./CarrierPage";
import BusinessPage from "./BusinessPage";
import './Merge.css';
import Home from "./Home";
import PartnershipPage from "./PartnershipPage";
import Chatbot from "../../Chatbot";

function Merge() {
    return (
        <div>
            <Routes>
                <Route path="/career" element={
                    <CarrierPage />
                }></Route>
                <Route path="" element={
                    <Home />
                }></Route>
                <Route path="/business" element={
                    <BusinessPage />
                }></Route>
                <Route path="/partnership" element={
                    <PartnershipPage></PartnershipPage>
                }></Route>
            </Routes>
            <Chatbot/>
        </div>
    )
}


export default Merge;